import If from "@mobi/components/If"


import { ChevronRightIcon, LockIcon } from "../../utils/icons"

const DropdownForm = ({
  currentForm,
  toggle,
  handleSubmit,
  onSubmitForm,
  isValid,
}) => {
  return (
    <div className={`ds-header__login ${toggle ? "-is-open" : ""}`}>
      <form className="ds-header__form" onSubmit={handleSubmit(onSubmitForm)}>
        {currentForm.form}
        <button
          className="ds-header__form-button-login"
          type="submit"
          disabled={!isValid}
          aria-label="enviar"
        >
          <If
            condition={isValid}
            renderIf={<ChevronRightIcon />}
            renderElse={<LockIcon />}
          />
        </button>
      </form>
      {currentForm.formhidden}
    </div>
  )
}

export default DropdownForm
